export enum HMDALoanType {
    Rental = 2,
    BuildRent = 3,
    FixFlip = 6,
    SubNoteFixFlip = 9,
    Bridge = 10,
}
